import { Button } from '@puzzlio/ui';
import { cn } from '@/app/lib/utils';
import { useCookieConsent } from '@/app/stores/cookie-consent-store';
import { useNoTracking } from '@/app/hooks/useNoTracking';
import Link from 'next/link';

export function BasicCookieBanner() {
  const { isAccepted, setIsAccepted, isDeclined, setIsDeclined, hasHydrated } = useCookieConsent();
  const isNoTracking = useNoTracking();

  function handleAccept() {
    setIsAccepted(true);
  }

  function handleDecline() {
    setIsDeclined(true);
  }

  const shouldHide = !hasHydrated || isAccepted || isDeclined || isNoTracking;

  return (
    <div
      className={cn(
        'border-coral-200 fixed bottom-0 left-0 z-50 w-full justify-center overflow-hidden border-t bg-white transition-[max-height,opacity] duration-300 ease-in-out',
        'max-h-0 opacity-0',
        !shouldHide && 'max-h-[400px] opacity-100'
      )}
    >
      <div className="mx-auto flex w-full max-w-6xl flex-col items-center gap-4 px-5 py-4 md:gap-6 md:px-8 md:py-6 lg:flex-row lg:justify-between">
        <div className="text-center lg:text-left">
          {/* Smaller on a phone, so the banner doesn't take over a small screen. */}
          <p className="text-sm md:text-base">
            We use cookies to make our website work properly and understand how visitors use our site.
          </p>
          <p className="mt-1 text-[13px] md:text-sm">
            For more details, see our{' '}
            <Link href="/cookies" prefetch={false} className="underline">
              Cookie page
            </Link>
            . To opt out of non-essential cookies, click{' '}
            <button onClick={handleDecline} className="underline">
              decline
            </button>
            .
          </p>
        </div>

        <div className="flex gap-3">
          <Button onClick={handleAccept} variant="gameplay" color="green" size="sm" className="max-w-max">
            Accept
          </Button>
        </div>
      </div>
    </div>
  );
}
